import React, { useEffect, useRef } from "react";
import "trix/dist/trix.css";
import "trix";

const TrixEditor = ({ id, value = "", onChange, placeholder = "" }) => {
  const editorRef = useRef(null);
  const inputRef = useRef(null);
  const isUpdatingFromParent = useRef(false);

  useEffect(() => {
    const editor = editorRef.current?.editor;
    if (!editor) {
      return undefined;
    }

    const handleChange = () => {
      if (isUpdatingFromParent.current) {
        isUpdatingFromParent.current = false;
        return;
      }

      const innerText = editor.getDocument().toString().trim();
      const innerHTML = editorRef.current.innerHTML.trim();
      onChange({ innerText, innerHTML });
    };

    editorRef.current.addEventListener("trix-change", handleChange);

    return () => {
      if (editorRef.current) {
        editorRef.current.removeEventListener("trix-change", handleChange);
      }
    };
  }, [onChange]);

  useEffect(() => {
    if (!editorRef.current || value === undefined) return;

    const { editor } = editorRef.current;
    const currentContent = editor.getDocument().toString().trim();

    if (value.trim() !== currentContent) {
      const selection = editor.getSelectedRange();
      isUpdatingFromParent.current = true;

      editor.setSelectedRange([0, editor.getDocument().getLength()]);
      editor.deleteInDirection("forward");
      editor.insertHTML(value);
      editor.setSelectedRange(selection);
    }
  }, [value]);

  return (
    <div>
      <input type="hidden" ref={inputRef} value={value} />
      <trix-editor
        id={id}
        ref={editorRef}
        input={inputRef.current?.id}
        placeholder={placeholder}
      ></trix-editor>
    </div>
  );
};

export default TrixEditor;
